export default {choose_newsletter:'Pilih buletin dalam daftar.',email_please:'Email kamu?'};